import React from "react";
import { useSeo, ORG_JSON_LD } from "../lib/seo";
import Header from "../components/landing/Header";
import Hero from "../components/landing/Hero";
import WinsTicker from "../components/landing/WinsTicker";
import LoopMethod from "../components/landing/LoopMethod";
import CalendarPreview from "../components/landing/CalendarPreview";
import QuizPromo from "../components/landing/QuizPromo";
import HabitLoopLeadMagnet from "../components/landing/HabitLoopLeadMagnet";
import Features from "../components/landing/Features";
import PricingSection from "../components/landing/PricingSection";
import ReferralLeaderboard from "../components/landing/ReferralLeaderboard";
import LatestBlogPosts from "../components/landing/LatestBlogPosts";
import Footer from "../components/landing/Footer";
import ExitIntentHabitLoopPopup from "../components/landing/ExitIntentHabitLoopPopup";

export default function Landing() {
  useSeo({
    title: "Financial Habits to Succeed — See Your Balance 30 Days Ahead",
    description: "A calendar-based Spending Plan that shows what your checking account will look like 30, 60, and 90 days from now — and the habit loop to make it grow. $10/month.",
    path: "/",
    jsonLd: ORG_JSON_LD,
  });
  return (
    <div className="min-h-screen bg-[#F7F5F0] text-[#2C302E]">
      <Header />
      <Hero />
      <WinsTicker />
      <LoopMethod />
      <CalendarPreview />
      <QuizPromo />
      <HabitLoopLeadMagnet />
      <Features />
      <LatestBlogPosts />
      <ReferralLeaderboard />
      <PricingSection />
      <Footer />
      <ExitIntentHabitLoopPopup />
    </div>
  );
}
